/** Product policy shared by the app, website and server. Amounts are USD. */
export const JAMCAM_PRICING = {
  freeImports: 2,
  unlock: { amount: 29, bonusImports: 2 },
  tabCredits: { amount: 12, imports: 10 },
} as const;
export const JAMCAM_PURCHASE_COUNTRIES = ['US', 'CA', 'GB', 'AU'] as const;
export const PURCHASE_UNAVAILABLE_MESSAGE =
  'Purchases are not available in your country yet. Please email support@jamcam.io if you have questions.';
